import { CallMeetingAttribution } from "@/interfaces/CallLog";
import { DateTime } from "luxon";
import { Link } from "react-router-dom";

const labels = {
  with_meeting: "RDV pris",
  pending: "Aucun RDV à ce stade",
  without_meeting: "Sans rendez-vous",
  ineligible: "Non éligible",
  unidentified: "Client non identifié",
  in_progress: "Résultat de l’appel en attente",
};
const paris = (value: string) =>
  DateTime.fromISO(value, { zone: "Europe/Paris" })
    .setZone("Europe/Paris")
    .toFormat("dd/MM/yyyy à HH:mm");

export default function CallMeetingResult({
  result,
}: {
  result?: CallMeetingAttribution;
}) {
  if (!result) return <span>—</span>;
  return (
    <div style={{ minWidth: 220 }}>
      <strong
        className={result.status === "with_meeting" ? "text-success" : ""}
      >
        {result.status === "with_meeting" && result.meetings.length > 1
          ? `${result.meetings.length} RDV pris`
          : labels[result.status]}
      </strong>
      {result.status === "pending" && result.deadlineAt && (
        <small className="d-block text-muted">
          Délai ouvert jusqu’au {paris(result.deadlineAt)}
        </small>
      )}
      {result.status === "without_meeting" && (
        <small className="d-block text-muted">Délai de 24 h écoulé</small>
      )}
      {result.meetings.map((meeting) => (
        <div key={meeting.id} className="mt-2">
          <Link
            to={`/companies/${meeting.companyId}?tab=${meeting.calendarType === "montage" ? "montage-meetings" : "meetings"}`}
          >
            {paris(meeting.startAt)} ·{" "}
            {meeting.calendarType === "montage" ? "Montage" : "Commercial"}
          </Link>
          <small className="d-block text-muted">
            Pris par {meeting.authorName || "Auteur non renseigné"} ·{" "}
            {paris(meeting.createdAt)}
          </small>
          <small className="d-block text-muted">
            Assuré par {meeting.ownerName || "Non attribué"}
          </small>
        </div>
      ))}
    </div>
  );
}
